import {axiosInstance} from "../utils/axios";

export const createAssignment = (assignmentData) => {
    return axiosInstance.post('teachers/assignments', assignmentData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}

export const updateAssignment = ({assignmentId, assignmentData}) => {
    return axiosInstance.put(`teachers/assignments/${assignmentId}`, assignmentData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}

export const getAssignmentList = (title = '', page = 0, size = 5) => {
    return axiosInstance.get(`teachers/assignments?title=${title}&page=${page}&size=${size}`);
}

export const getQuestionList = (title = '', page = 0, size = 5) => {
    return axiosInstance.get(`teachers/assignments?title=${title}&page=${page}&size=${size}`);
}


export const deleteAssignment = (assignmentList) => {
    return axiosInstance.delete(`teachers/assignments`, {
        data: assignmentList
    });
}
